(function () {
  function qs(el, sel) { return el.querySelector(sel); }
  function qsa(el, sel) { return Array.from(el.querySelectorAll(sel)); }

  function buildShareLinks(baseUrl, title) {
    const url = encodeURIComponent(baseUrl);
    const text = encodeURIComponent(title || '');
    return {
      whatsapp: `https://wa.me/?text=${text}%20${url}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      x: `https://twitter.com/intent/tweet?text=${text}&url=${url}`,
      email: `mailto:?subject=${text}&body=${url}`
    };
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  function initWrap(wrap) {
    const video = qs(wrap, 'video.apg__video');
    const shareBtn = qs(wrap, '.apg__shareBtn');
    const bigPlay = qs(wrap, '.apg__bigPlay');
    const sharePop = qs(wrap, '.apg__sharePop');
    const toast = qs(wrap, '.apg__toast');

    const shareTitle = wrap.getAttribute('data-share-title') || document.title;
    const shareUrl = wrap.getAttribute('data-share-url') || window.location.href;

    // If it's not an MP4 video element (YouTube/Vimeo iframe), remove bigPlay overlay
    if (!video && bigPlay) bigPlay.style.display = 'none';

    // MP4: play/pause overlay like Figma
    function updateBigPlay() {
      if (!video || !bigPlay) return;
      const shouldShow = video.paused || video.ended;
      bigPlay.style.display = shouldShow ? 'flex' : 'none';
    }

    if (video && bigPlay) {
      updateBigPlay();
      video.addEventListener('play', updateBigPlay);
      video.addEventListener('pause', updateBigPlay);
      video.addEventListener('ended', updateBigPlay);

      bigPlay.addEventListener('click', function () {
        if (video.paused) video.play();
        else video.pause();
      });
    }

    // Share popover / native share
    function hidePop() {
      if (sharePop) sharePop.hidden = true;
    }
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.hidden = false;
      window.clearTimeout(toast._t);
      toast._t = window.setTimeout(() => { toast.hidden = true; }, 1600);
    }

    if (shareBtn && sharePop) {
      const links = buildShareLinks(shareUrl, shareTitle);

      qsa(sharePop, '[data-share-action]').forEach((el) => {
        const act = el.getAttribute('data-share-action');
        if (act === 'whatsapp') el.href = links.whatsapp;
        if (act === 'facebook') el.href = links.facebook;
        if (act === 'x') el.href = links.x;
        if (act === 'email') el.href = links.email;

        if (act === 'copy') {
          el.addEventListener('click', async () => {
            await copyText(shareUrl);
            showToast('Link copied');
            hidePop();
          });
        }
      });

      shareBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        if (navigator.share) {
          try {
            await navigator.share({ title: shareTitle, url: shareUrl });
            return;
          } catch (_) {}
        }
        sharePop.hidden = !sharePop.hidden;
      });

      document.addEventListener('click', (e) => {
        if (!wrap.contains(e.target)) hidePop();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') hidePop();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.apg__videoWrap').forEach(initWrap);
  });
})();
